import React from 'react';
import SoldeCard from './SoldeCard';
import HistoriqueTransaction from './HistoriqueTransaction';
import ListeInstitutions from './ListeInstitutions';
import './AbonneDashboard.css';

function AbonneDashboard() {

    // Données simulées pour le tableau de bord
  const solde = 450000; // Solde actuel de la carte
  const typeCarte = 'Adulte'; // Type de carte (Adulte ou Mineur)
  const cardNo = '111 888 552 5478';

  const transactions = [
    { date: '2023-10-01', institution: 'Hôpital Général', montant: 50000, service: 'Consultation médicale' },
    { date: '2023-10-05', institution: 'Clinique ABC', montant: 30000, service: 'Analyse sanguine' },
    { date: '2023-10-10', institution: 'Restaurant XYZ', montant: 15000, service: 'Repas' },
  ];

  const institutions = [
    { nom: 'Hôpital Général', type: 'Hôpital', adresse: 'Bamako, Mali' },
    { nom: 'Clinique ABC', type: 'Clinique', adresse: 'Bamako, Mali' },
    { nom: 'Laboratoire XYZ', type: 'Laboratoire', adresse: 'Bamako, Mali' },
    { nom: 'Restaurant 123', type: 'Restaurant', adresse: 'Bamako, Mali' },
  ];

  return (
    <div className="tableau-de-bord">
      <h1>Tableau de bord du bénéficiaire</h1>
      <SoldeCard solde={solde} typeCarte={typeCarte} cardNo={cardNo} />
      <HistoriqueTransaction transactions ={transactions} />
      <ListeInstitutions institutions={institutions} />
    </div>
  )
}

export default AbonneDashboard